/** @flow */
import React from "react";
import classNames from "classnames";

type SectionItemProps = {
  border?: boolean,
  label: string | React$Node,
  value?: string | React$Node,
  form?: string | React$Node,
  editable?: boolean,
  highlight?: boolean,
  rightAction?: string | React$Node,
  horizontal?: boolean,
  className?: string,
};

const SectionItem = (props: SectionItemProps) => (
  <div
    className={classNames(
      "item",
      {
        "with-border": props.border,
        highlight: props.highlight,
        "d-flex": props.rightAction,
      },
      props.className,
    )}
  >
    <div
      className={classNames("item-wrapper", {
        "d-flex horizontal": props.horizontal,
      })}
    >
      <div className="item-label">{props.label}</div>
      {!props.editable ? <div className="item-value">{props.value}</div> : null}
      {props.form && props.editable ? <div className="item-input">{props.form}</div> : null}
    </div>
    {props.rightAction && !props.editable ? (
      <div className="item-right">{props.rightAction}</div>
    ) : null}
  </div>
);

export default SectionItem;
